function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { AngularFormControllerErrorAdapter, MetadataActions, MetadataConstants, MetadataSelectors, SessionSelectors, i18n } from 'invision-core';
import { stateGo } from 'redux-ui-router';
import moment from 'moment';
import { NOTIFICATION_TIME_LENGTH } from '../../../../customercare.constants';
import { HOUSEHOLD_STATE_NAME } from '../household.constants';
import { CurrentCustomerIdSelector, RouteParams } from '../../../../reducers/selectors/customer.selectors';
import { IsRetrievingEwalletDataSelector, ShareablePaymentInstrumentsWithTypeNamesViewModel } from '../../../../reducers/selectors/customer.ewallet.selectors';
import { CurrentHouseholdSelector, CurrentMemberIsHeadOfHouseholdSelector, EnableHouseholdFullAccessControlSelector, EnableHouseholdAccessPrivilegesSelector, EnableHouseholdServiceLevelManagementSelector, EnableHouseholdUsagePrivilegesSelector, HouseholdErrorSelector, IsUpdatingHouseholdSelector, RecoverablePaymentInstrumentsSelector, RecoverablePrivilegesSelector, RecoverableSelectedHoursSelector, SelectableRatingsByCategory, SelectedHouseholdMemberSelector, SelectedMemberPrivilegesAPIRequestSelector, SelectedMemberPrivilegesSelector } from '../../../../reducers/selectors/customer.household.selectors';
import { retrieveWallet } from '../../../../reducers/actions/customer.ewallet.actions';
import { resetUiState, retrieveCustomerHouseholds, setAvailablePaymentInstruments, setMemberPrivilege, setSelectedHouseholdMember, setSelectedHours, setSelectedHoursForHouseholdMember, updateHouseholdMember } from '../../../../reducers/actions/customer.household.actions';
import { getMemberBySubscriberId } from '../household.helpers';
import localeKeys from '../../../../locales/keys';
var MIN_CURRENCY = 0.01;
var NIGHT_HOUR_START = 17;
var NIGHT_HOUR_END = 20;
var WEEKEND_HOUR_START = 8;
var WEEKEND_HOUR_END = 20;
var MemberPrivilegesController = /*#__PURE__*/function () {
  function MemberPrivilegesController($ngRedux, $timeout, uiNotificationService) {
    _classCallCheck(this, MemberPrivilegesController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $timeout: $timeout,
      uiNotificationService: uiNotificationService,
      HOUSEHOLD_STATE_NAME: HOUSEHOLD_STATE_NAME,
      minCurrency: MIN_CURRENCY,
      vm: {
        categories: [],
        privileges: {},
        paymentInstruments: [],
        recoverableSelectedHours: []
      }
    });
  }
  return _createClass(MemberPrivilegesController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          currentCustomerId: CurrentCustomerIdSelector(store),
          currentHeadOfHousehold: CurrentMemberIsHeadOfHouseholdSelector(store),
          currentHousehold: CurrentHouseholdSelector(store),
          enableHouseholdFullAccessControl: EnableHouseholdFullAccessControlSelector(store),
          enableHouseholdAccessPrivileges: EnableHouseholdAccessPrivilegesSelector(store),
          enableHouseholdServiceLevelManagement: EnableHouseholdServiceLevelManagementSelector(store),
          enableHouseholdUsagePrivileges: EnableHouseholdUsagePrivilegesSelector(store),
          hasLoadedHouseholdPrivileges: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.HouseholdPrivileges, store),
          hasLoadedRatingCategories: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.RatingCategory, store),
          hasLoadedRatings: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.Rating, store),
          hasLoadedTimezones: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.TimeZone, store),
          householdError: HouseholdErrorSelector(store),
          isFetchingEwalletData: IsRetrievingEwalletDataSelector(store),
          isUpdatingHouseholdData: IsUpdatingHouseholdSelector(store),
          language: SessionSelectors.LanguageSelector(store),
          paymentInstruments: ShareablePaymentInstrumentsWithTypeNamesViewModel(store),
          privilegeRequest: SelectedMemberPrivilegesAPIRequestSelector(store),
          privileges: SelectedMemberPrivilegesSelector(store),
          ratingsOptions: SelectableRatingsByCategory(store),
          recoverablePaymentInstruments: RecoverablePaymentInstrumentsSelector(store),
          recoverablePrivileges: RecoverablePrivilegesSelector(store),
          recoverableSelectedHours: RecoverableSelectedHoursSelector(store),
          routeParams: RouteParams(store),
          selectableRatingsByCategory: SelectableRatingsByCategory(store),
          selectedHouseholdMember: SelectedHouseholdMemberSelector(store),
          timezoneOptions: MetadataSelectors.codes.MetadataOptionsForCodeValuesSelector(MetadataConstants.codes.TimeZone, store)
        };
      };
      var controllerActions = {
        fetchPrivileges: function fetchPrivileges() {
          return MetadataActions.codes.fetchCodeTypes(MetadataConstants.codes.HouseholdPrivileges);
        },
        fetchRatings: function fetchRatings() {
          return MetadataActions.codes.fetchCodeTypes(MetadataConstants.codes.Rating);
        },
        fetchRatingsCategory: function fetchRatingsCategory() {
          return MetadataActions.codes.fetchCodeTypes(MetadataConstants.codes.RatingCategory);
        },
        fetchTimezones: function fetchTimezones() {
          return MetadataActions.codes.fetchCodeTypes(MetadataConstants.codes.TimeZone);
        },
        resetUiState: resetUiState,
        retrieveWallet: retrieveWallet,
        retrieveCustomerHouseholds: retrieveCustomerHouseholds,
        setAvailablePaymentInstruments: setAvailablePaymentInstruments,
        setMemberPrivilege: setMemberPrivilege,
        setSelectedHours: setSelectedHours,
        setSelectedHouseholdMember: setSelectedHouseholdMember,
        setSelectedHoursForHouseholdMember: setSelectedHoursForHouseholdMember,
        stateGo: stateGo,
        updateHouseholdMember: updateHouseholdMember
      };
      this.disconnect = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.currentDateTime = new Date();
      this.LocaleKeys = localeKeys;
      this.stateOrName = 'index.customercare.customer.memberprivileges';
      this.formErrors = [];
      this.formFieldLocaleKeyMapping = {
        accumulateDate: this.LocaleKeys.HOUSEHOLD.PRIVILEGES.ACCUMULATE_DATE,
        spendingLimit: this.LocaleKeys.HOUSEHOLD.PRIVILEGES.SPENDING_LIMIT,
        daysForLimit: this.LocaleKeys.HOUSEHOLD.PRIVILEGES.DAYS_FOR_SPENDING_LIMIT,
        selectedPaymentInstrument: this.LocaleKeys.HOUSEHOLD.PRIVILEGES.SHARE_PAYMENT_METHODS
      };
      this.retrieveData();
      this.dayHeaders = Array.from(new Array(7), function (i, index) {
        return moment().weekday(index).format('dd');
      });
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.actions.resetUiState();
      this.disconnect();
    }
  }, {
    key: "toggleEnforcePaymentPrivileges",
    value: function toggleEnforcePaymentPrivileges() {
      this.setMemberPrivilege({
        EnforcePaymentPrivileges: this.vm.privileges.EnforcePaymentPrivileges
      });
      if (!this.vm.privileges.EnforcePaymentPrivileges) {
        this.setMemberPrivilege({
          CreatePaymentInstrumentEnabled: false,
          LimitSpending: false
        });
        this.vm.paymentInstruments.forEach(function (p) {
          p.selected = false;
        });
        this.updateSelectedPaymentInstruments(this.vm.paymentInstruments);
      }
    }
  }, {
    key: "selectTimezone",
    value: function selectTimezone() {
      this.setMemberPrivilege({
        Timezone: this.vm.privileges.Timezone
      });
    }
  }, {
    key: "toggleEnforceAccessPrivileges",
    value: function toggleEnforceAccessPrivileges() {
      this.setMemberPrivilege({
        EnforceAccessPrivileges: this.vm.privileges.EnforceAccessPrivileges
      });
    }
  }, {
    key: "toggleEnforceUsagePrivileges",
    value: function toggleEnforceUsagePrivileges() {
      this.setMemberPrivilege({
        EnforceUsagePrivileges: this.vm.privileges.EnforceUsagePrivileges
      });
    }
  }, {
    key: "toggleCreatePaymentMethod",
    value: function toggleCreatePaymentMethod() {
      this.setMemberPrivilege({
        CreatePaymentInstrumentEnabled: this.vm.privileges.CreatePaymentInstrumentEnabled
      });
      this.validateForm();
    }
  }, {
    key: "toggleLimitSpending",
    value: function toggleLimitSpending() {
      this.setMemberPrivilege({
        LimitSpending: this.vm.privileges.LimitSpending
      });
      this.validateForm();
    }
  }, {
    key: "toggleFullAccessPrivileges",
    value: function toggleFullAccessPrivileges() {
      this.setMemberPrivilege({
        MemberManagementEnabled: this.vm.privileges.MemberManagementEnabled
      });
    }
  }, {
    key: "toggleManageServicePrivileges",
    value: function toggleManageServicePrivileges() {
      this.setMemberPrivilege({
        ManageServicesEnabled: this.vm.privileges.ManageServicesEnabled
      });
    }
  }, {
    key: "updateSpendingLimit",
    value: function updateSpendingLimit() {
      this.setMemberPrivilege({
        SpendingLimitAmount: this.vm.privileges.SpendingLimitAmount
      });
      this.validateForm();
    }
  }, {
    key: "updateSpendingLimitPeriodDays",
    value: function updateSpendingLimitPeriodDays() {
      this.setMemberPrivilege({
        SpendingLimitPeriodDays: this.vm.privileges.SpendingLimitPeriodDays
      });
      this.validateForm();
    }
  }, {
    key: "updateNextSpendingDeposit",
    value: function updateNextSpendingDeposit() {
      this.setMemberPrivilege({
        NextSpendingDeposit: this.vm.privileges.NextSpendingDeposit
      });
      this.validateForm();
    }
  }, {
    key: "setMemberPrivilege",
    value: function setMemberPrivilege() {
      var _this2 = this;
      var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.vm.privileges;
      return this.actions.setMemberPrivilege(payload).then(function () {
        _this2.vm.privileges = _this2.state.recoverablePrivileges.asMutable({
          deep: true
        });
      });
    }
  }, {
    key: "setAvailablePaymentInstruments",
    value: function setAvailablePaymentInstruments(toUpdate) {
      var _this3 = this;
      this.actions.setAvailablePaymentInstruments(toUpdate).then(function () {
        _this3.vm.paymentInstruments = _this3.state.recoverablePaymentInstruments.asMutable({
          deep: true
        });
      });
    }
  }, {
    key: "selectRating",
    value: function selectRating() {
      var selectedRatings = this.vm.categories.filter(function (_ref) {
        var selected = _ref.selected;
        return selected;
      });
      this.setMemberPrivilege({
        RatingPrivileges: selectedRatings.reduce(function (selectedItems, category) {
          return category.selected ? selectedItems.concat(category.selected) : selectedItems;
        }, [])
      });
    }
  }, {
    key: "buildSelectedMemberDto",
    value: function buildSelectedMemberDto() {
      return {
        Privileges: this.state.privilegeRequest,
        SubscriberId: parseInt(this.state.routeParams.subscriberId)
      };
    }
  }, {
    key: "retrieveData",
    value: function retrieveData() {
      var _this4 = this;
      var promises = [];
      if (!this.state.hasLoadedRatings) {
        promises.push(this.actions.fetchRatings());
      }
      if (!this.state.hasLoadedRatingCategories) {
        promises.push(this.actions.fetchRatingsCategory());
      }
      if (!this.state.hasLoadedTimezones) {
        promises.push(this.actions.fetchTimezones());
      }
      if (!this.state.hasLoadedHouseholdPrivileges) {
        this.actions.fetchPrivileges();
      }
      if (this.state.currentHousehold) {
        promises.push(this.getPaymentInstruments());
      } else {
        promises.push(this.actions.retrieveCustomerHouseholds(this.state.currentCustomerId, false).then(function () {
          _this4.getPaymentInstruments();
          if (!_this4.state.currentHeadOfHousehold) {
            _this4.actions.updateHouseholdMember(_this4.state.routeParams.customerId, _this4.state.currentHousehold.Id, _this4.buildSelectedMemberDto());
          }
        }));
      }
      return Promise.all(promises).then(function () {
        _this4.selectMember();
        _this4.setMemberPrivilege(_this4.state.privileges);
        _this4.vm.categories = _this4.state.ratingsOptions;
        _this4.vm.selectedHours = _this4.state.recoverableSelectedHours.asMutable({
          deep: true
        });
        _this4.checkWeekends();
        _this4.checkNights();
      });
    }
  }, {
    key: "getPaymentInstruments",
    value: function getPaymentInstruments() {
      var _this5 = this;
      return this.actions.retrieveWallet({
        customerId: this.state.currentHousehold.HeadOfHouseholdSubscriberId
      }).then(function () {
        _this5.selectPaymentInstruments();
      });
    }
  }, {
    key: "selectMember",
    value: function selectMember() {
      var memberId = parseInt(this.state.routeParams.subscriberId, 10);
      var member = getMemberBySubscriberId(this.state.currentHousehold.Members, memberId);
      this.actions.setSelectedHouseholdMember(member.SubscriberId);
      this.actions.setSelectedHoursForHouseholdMember(member);
    }
  }, {
    key: "updateSelectedPaymentInstruments",
    value: function updateSelectedPaymentInstruments() {
      var toUpdate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.vm.paymentInstruments;
      this.setAvailablePaymentInstruments(toUpdate);
      this.setMemberPrivilege({
        PaymentInstrumentPrivileges: toUpdate.filter(function (_ref2) {
          var selected = _ref2.selected;
          return selected;
        }).map(function (_ref3) {
          var Id = _ref3.Id;
          return Id;
        })
      });
    }
  }, {
    key: "selectPaymentInstruments",
    value: function selectPaymentInstruments() {
      var _this6 = this;
      var toUpdate = this.state.paymentInstruments.map(function (paymentInstrument) {
        return Object.assign({
          selected: (_this6.state.privileges.PaymentInstrumentPrivileges || []).includes(paymentInstrument.Id)
        }, paymentInstrument);
      });
      this.updateSelectedPaymentInstruments(toUpdate);
    }
  }, {
    key: "updateUsagePrivileges",
    value: function updateUsagePrivileges() {
      var _this7 = this;
      var toUpdate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.vm.selectedHours;
      this.checkNights();
      this.checkWeekends();
      this.actions.setSelectedHours(toUpdate, this.state.selectedHouseholdMemberId).then(function () {
        _this7.vm.selectedHours = _this7.state.recoverableSelectedHours.asMutable({
          deep: true
        });
      });
    }
  }, {
    key: "checkNights",
    value: function checkNights() {
      var _this8 = this;
      var allSelected = true;
      this.vm.selectedHours.forEach(function (hour) {
        if (_this8.isNightHour(hour)) {
          hour.days.forEach(function (day) {
            if (!day.selected) {
              _this8.vm.isNights = false;
              allSelected = false;
            }
          });
        }
      });
      this.vm.isNights = allSelected;
    }
  }, {
    key: "checkWeekends",
    value: function checkWeekends() {
      var _this9 = this;
      var allSelected = true;
      this.vm.selectedHours.forEach(function (hour) {
        if (_this9.isWeekendHour(hour)) {
          hour.days.forEach(function (day) {
            if (_this9.isWeekend(hour, day) && !day.selected) {
              _this9.vm.isWeekends = false;
              allSelected = false;
            }
          });
        }
      });
      this.vm.isWeekends = allSelected;
    }
  }, {
    key: "selectNights",
    value: function selectNights() {
      var _this10 = this;
      this.vm.selectedHours.forEach(function (hour) {
        if (_this10.isNightHour(hour)) {
          hour.days.forEach(function (day) {
            if (_this10.vm.isWeekends && _this10.isWeekend(hour, day)) {
              day.selected = _this10.vm.isWeekends;
            } else {
              day.selected = _this10.vm.isNights;
            }
          });
        }
      });
      this.updateUsagePrivileges();
    }
  }, {
    key: "selectWeekends",
    value: function selectWeekends() {
      var _this11 = this;
      this.vm.selectedHours.forEach(function (hour) {
        if (_this11.isWeekendHour(hour)) {
          hour.days.forEach(function (day) {
            if (_this11.vm.isNights && _this11.isNightHour(hour)) {
              day.selected = _this11.vm.isNights;
            } else if (_this11.isWeekend(hour, day)) {
              day.selected = _this11.vm.isWeekends;
            }
          });
        }
      });
      this.updateUsagePrivileges();
    }
  }, {
    key: "isWeekendHour",
    value: function isWeekendHour(hour) {
      return hour.hour >= WEEKEND_HOUR_START && hour.hour <= WEEKEND_HOUR_END;
    }
  }, {
    key: "isWeekend",
    value: function isWeekend(hour, day) {
      // weekends are 8-9 Saturday, Sunday and 5-9pm Friday with this logic
      // a refactor may be needed if we support different 'weekends'
      return day.day === 5 && this.isNightHour(hour) || day.day === 0 || day.day === 6;
    }
  }, {
    key: "isNightHour",
    value: function isNightHour(hour) {
      return hour.hour >= NIGHT_HOUR_START && hour.hour <= NIGHT_HOUR_END;
    }
  }, {
    key: "savePrivileges",
    value: function savePrivileges() {
      var _this12 = this;
      if (this.formApi.$valid) {
        this.actions.updateHouseholdMember(this.state.currentHousehold.HeadOfHouseholdSubscriberId, this.state.currentHousehold.Id, this.buildSelectedMemberDto()).then(function (_ref4) {
          var UpdatedHouseholdMembers = _ref4.UpdatedHouseholdMembers;
          _this12.formApi.$setPristine();
          _this12.actions.stateGo(HOUSEHOLD_STATE_NAME);
          _this12.uiNotificationService.success(i18n.translate(_this12.LocaleKeys.HOUSEHOLD.MEMBER_UPDATE_SUCCESS), null, {
            timeOut: NOTIFICATION_TIME_LENGTH
          });
          _this12.setMemberPrivilege(UpdatedHouseholdMembers[0].Privileges);
        }).catch(function () {
          _this12.uiNotificationService.error(_this12.state.householdError.message, null, {
            timeOut: NOTIFICATION_TIME_LENGTH
          });
        });
      } else {
        this.validateForm();
      }
    }
  }, {
    key: "validateForm",
    value: function validateForm() {
      var _this13 = this;
      this.$timeout(function () {
        _this13.formErrors = AngularFormControllerErrorAdapter(_this13.formApi, _this13.formFieldLocaleKeyMapping);
        _this13.formErrorMessages = _this13.formErrors.filter(function (error) {
          return error;
        });
        if (_this13.vm.privileges.LimitSpending) {
          if (_this13.formApi.accumulateDate.$error['minDate']) {
            _this13.formErrorMessages.push(i18n.translate(_this13.LocaleKeys.HOUSEHOLD.ERRORS.ACCUMULATE_MIN_DATE));
          } else if (_this13.formApi.accumulateDate.$error['invalidDate']) {
            _this13.formErrorMessages.push(i18n.translate(_this13.LocaleKeys.HOUSEHOLD.ERRORS.ACCUMULATE_DATE_INVALID));
          }
        }
      });
      if (this.vm.privileges.SpendingLimitAmount === 'null') {
        this.setMemberPrivileges({
          SpendingLimitAmount: undefined
        });
      }
      this.setMemberPrivilege();
    }
  }, {
    key: "isLoading",
    value: function isLoading() {
      return this.state.isFetchingEwalletData || this.state.isUpdatingHouseholdData;
    }
  }, {
    key: "showFormErrors",
    value: function showFormErrors(fieldName) {
      return this.formApi[fieldName].$invalid && (this.formApi.$submitted || this.formApi[fieldName].$touched);
    }
  }, {
    key: "showThreeDateFormErrors",
    value: function showThreeDateFormErrors() {
      return this.formApi.accumulateDate.$error['invalidDate'] || this.formApi.accumulateDate.$error['required'] || this.formApi.accumulateDate.$error['minDate'];
    }
  }, {
    key: "clearForm",
    value: function clearForm() {
      this.formApi.$setPristine();
      this.actions.stateGo(this.HOUSEHOLD_STATE_NAME);
    }
  }, {
    key: "areInstrumentsRequired",
    value: function areInstrumentsRequired() {
      var limitSpending = !!this.vm.privileges.LimitSpending;
      return limitSpending && !this.vm.paymentInstruments.find(function (instrument) {
        return instrument.selected;
      });
    }
  }, {
    key: "getHourOfDay",
    value: function getHourOfDay(hour) {
      return moment().hour(hour).minute(0).format('hh:mm a');
    }
  }]);
}();
export default {
  template: require('./member.privileges.template.html'),
  bindings: {},
  controllerAs: 'MemberPrivilegesController',
  controller: MemberPrivilegesController
};